












import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
})
export default class Tab extends Vue {
  @Prop() title!: string
  @Prop({ required: false }) segmentCount!: number
  @Prop({ required: true }) isActive!: boolean
  @Prop({ required: false }) beta!: boolean

  get displayTitle () {
    if (typeof this.segmentCount === 'number') {
      return `${this.title} (N=${this.segmentCount})`
    } else {
      return this.title
    }
  }
}
